import { render, staticRenderFns } from "./cassation-reason-form.vue?vue&type=template&id=8803fc90&scoped=true&"
import script from "./cassation-reason-form.vue?vue&type=script&lang=js&"
export * from "./cassation-reason-form.vue?vue&type=script&lang=js&"
import style0 from "./cassation-reason-form.vue?vue&type=style&index=0&id=8803fc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8803fc90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow,VTooltip})
